import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccueilComponent } from './accueil/accueil.component';
import { environment } from '../environments/environment';
import { TarifComponent } from './tarif/tarif.component';
import { CarousselComponent } from './caroussel/caroussel.component';
import { MenuComponent } from './menu/menu.component';
import { CoverComponent } from './cover/cover.component';
import { CalendarComponent } from './calendar/calendar.component';
import { AlbumComponent } from './album/album.component';
import { MyfooterComponent } from './myfooter/myfooter.component';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { PubliposteComponent } from './publiposte/publiposte.component';
import { AdminComponent } from './admin/admin.component';
import { KlixService } from './services/klix.service';

@NgModule({
  declarations: [
    AppComponent,
    AccueilComponent,
    TarifComponent,
    CarousselComponent,
    MenuComponent,
    CoverComponent,
    CalendarComponent,
    AlbumComponent,
    MyfooterComponent,
    PubliposteComponent,
    AdminComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpModule,
    JsonpModule,
  ],
  providers: [KlixService],
  bootstrap: [AppComponent]
})
export class AppModule { }
